import * as types from './logSourcesActionTypes';
import _ from 'lodash';

export default function logSourcesReducer(state = [], action) {
    switch(action.type) {
        case types.LOAD_LOG_SOURCES_SUCCESS:
            return [...action.logSources.devices];
        case types.SORT_LOG_SOURCES:
        {
            const sortBy =  action.sort.func ? action.sort.func : action.sort.by;
            const direction = action.sort.direction;

            return _.orderBy(state, [sortBy], [direction]);
        }
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/log-sources/logSourcesReducer.js